import { defineComponent, h } from 'vue'
import { QToggle } from 'quasar'

import { bsComponentProps, useBsComponent } from '../useBsComponent'
import { useVm } from '../../../composables/useVm'
import { quasarHandlers } from '../quasarHandlers'

/**
 * The "I agree" switch. A toggle whose only valid state is on, so `required` means *checked*, not
 * *filled in* — hence the `isComponentValid` override.
 *
 * `autoSaveMethod: ''` plus `forceTriggerOnChange` is the combination that saves on every click: the
 * shared blur listener is off, and the value watcher does the save instead.
 */
export default defineComponent({
  name: 'BsCheckToggle',

  // See BsBtn: Vue 3 merges attribute fallthrough OVER the render's props, so a caller's `color` beat
  // the error colour this computes. The render forwards $attrs itself, first.
  inheritAttrs: false,

  // See BsInput: undeclared DOM-named events are bound twice, once natively.
  emits: [ 'input', 'update:modelValue' ],

  props: { ...bsComponentProps },

  setup (props, { emit }) {
    const vm = useVm()
    const bs = useBsComponent({
      vm,
      props,
      emit,
      autoSaveMethod: '',
      isComponentValid: (val?: any) => val === true
    })

    bs.forceTriggerOnChange.value = true

    return { ...bs }
  },

  render (): any {
    return h(QToggle, {
      ...this.$attrs,
      class: [this.$attrs.class, 'bs-check-toggle flex-start'],
      ...this.getRenderProps({
        keepColor: true,
        color: this.$attrs.color || 'bs-lb-m'
      }),
      ...quasarHandlers(this.getListeners()),
      ...this.getAttributes()
    }, this.getSlots())
  }
})
